<template>
  <div>
    <notifications></notifications>
    <router-view :key="$route.fullPath"></router-view>
  </div>
</template>

<script>
  export default {
    methods: {
      disableRTL() {
        if (!this.$rtl.isRTL) {
          this.$rtl.disableRTL();
        }
      },
      toggleNavOpen() {
        let root = document.getElementsByTagName('html')[0];
        root.classList.toggle('nav-open');
      },
      upsertMetaTag(selector, attrs) {
        let tag = document.head.querySelector(selector);

        if (!tag) {
          tag = document.createElement("meta");
          document.head.appendChild(tag);
        }

        Object.keys(attrs).forEach((key) => {
          tag.setAttribute(key, attrs[key]);
        });
      },
      upsertLinkTag(rel, href) {
        let tag = document.head.querySelector(`link[rel="${rel}"]`);

        if (!href) {
          if (tag) {
            tag.remove();
          }
          return;
        }

        if (!tag) {
          tag = document.createElement("link");
          tag.setAttribute("rel", rel);
          document.head.appendChild(tag);
        }

        tag.setAttribute("href", href);
      },
      upsertStructuredData(schema) {
        let tag = document.head.querySelector("#app-structured-data");

        if (!schema) {
          if (tag) {
            tag.remove();
          }
          return;
        }

        if (!tag) {
          tag = document.createElement("script");
          tag.setAttribute("type", "application/ld+json");
          tag.setAttribute("id", "app-structured-data");
          document.head.appendChild(tag);
        }

        tag.textContent = JSON.stringify(schema);
      },
      getDefaultRobots(routeMeta = {}) {
        return routeMeta.public === true
          ? "index, follow, max-image-preview:large"
          : "noindex, nofollow";
      },
      applyRouteSeo(route) {
        const title = route.meta.title || "ittec-P&M";
        const description =
          route.meta.description ||
          "ITTEC P&M, pieces techniques, maintenance, fourniture et formation.";
        const robots = route.meta.robots || this.getDefaultRobots(route.meta);
        const canonical =
          route.meta.public === true
            ? route.meta.canonical || `${window.location.origin}${route.path}`
            : null;

        document.title = title;

        this.upsertMetaTag('meta[name="description"]', {
          name: "description",
          content: description,
        });
        this.upsertMetaTag('meta[name="robots"]', {
          name: "robots",
          content: robots,
        });
        this.upsertMetaTag('meta[property="og:title"]', {
          property: "og:title",
          content: title,
        });
        this.upsertMetaTag('meta[property="og:description"]', {
          property: "og:description",
          content: description,
        });
        this.upsertMetaTag('meta[property="og:type"]', {
          property: "og:type",
          content: "website",
        });
        this.upsertMetaTag('meta[property="og:url"]', {
          property: "og:url",
          content: canonical || `${window.location.origin}${route.path}`,
        });
        this.upsertMetaTag('meta[name="twitter:card"]', {
          name: "twitter:card",
          content: "summary_large_image",
        });
        this.upsertMetaTag('meta[name="twitter:title"]', {
          name: "twitter:title",
          content: title,
        });
        this.upsertMetaTag('meta[name="twitter:description"]', {
          name: "twitter:description",
          content: description,
        });

        this.upsertLinkTag("canonical", canonical);
        this.upsertStructuredData(route.meta.schema || null);
      }
    },
    mounted() {
      //this.$watch('$route', this.disableRTL, { immediate: true });
      //this.$watch('$sidebar.showSidebar', this.toggleNavOpen)
    },

    watch: {
        $route: {
            immediate: true,
            handler(to) {
                this.applyRouteSeo(to);
            }
        },
    }
  };
</script>

<style lang="scss">
.app-popup-shell {
  background: rgba(15, 23, 42, 0.28) !important;
  backdrop-filter: blur(3px);
}

.app-popup-shell .modal-dialog {
  margin: 1.75rem auto;
  transform: translateY(22px) scale(0.97);
  transition: transform 0.28s ease, opacity 0.28s ease;
}

.app-popup-shell.show .modal-dialog {
  transform: translateY(0) scale(1);
}

.app-popup-content {
  border: 0 !important;
  border-radius: 24px !important;
  background: linear-gradient(180deg, #f4f7fb 0%, #edf2f7 100%) !important;
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.22) !important;
  overflow: hidden;
}

.app-popup-header {
  padding: 10px 14px 0 !important;
  border-bottom: 0 !important;
  background: transparent !important;
  justify-content: flex-end;
}

.app-popup-header .close {
  margin: 0 0 0 auto !important;
  padding: 0.35rem 0.8rem !important;
  border-radius: 999px;
  background: #1e2a44;
  color: #fff !important;
  opacity: 1 !important;
  font-size: 1.2rem;
  line-height: 1;
  text-shadow: none !important;
  box-shadow: 0 10px 24px rgba(30, 42, 68, 0.18);
}

.app-popup-header .close:hover {
  background: #31415f;
}

.app-popup-header .modal-title {
  display: none;
}

.app-popup-body {
  padding: 10px 22px 22px !important;
  max-height: calc(100vh - 160px);
  overflow-y: auto;
}

.app-popup-body::-webkit-scrollbar {
  width: 10px;
}

.app-popup-body::-webkit-scrollbar-thumb {
  border-radius: 999px;
  background: rgba(95, 111, 139, 0.42);
}

.app-popup-body-compact {
  padding-top: 4px !important;
}

.app-popup-body .editionPanel,
.app-popup-body .editionZonePanel,
.app-popup-body .editionZoneParamsPanel,
.app-popup-body .recap,
.app-popup-body .history,
.app-popup-body .info {
  border-radius: 20px !important;
}

.app-popup-body .editionPanel,
.app-popup-body .editionZonePanel,
.app-popup-body .editionZoneParamsPanel,
.app-popup-body .recap {
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.08);
}

.app-popup-body .editionPanel {
  padding: 3% 1% !important;
  background-color: #ffffff !important;
  border: 1px solid #dbe4f0 !important;
}

.app-popup-body .editionZonePanel,
.app-popup-body .editionZoneParamsPanel {
  padding: 22px !important;
  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%) !important;
  border: 1px solid #dbe4f0 !important;
}

.app-popup-body .row {
  row-gap: 12px;
}

.app-popup-body .form-control,
.app-popup-body .custom-select,
.app-popup-body textarea,
.app-popup-body .custom-select,
.app-popup-body .input-group-text {
  border-radius: 12px !important;
}

.app-popup-body .editionPanel .form-control,
.app-popup-body .editionPanel .custom-select,
.app-popup-body .editionPanel textarea,
.app-popup-body .editionPanel .input-group-text,
.app-popup-body .editionPanel .vs__dropdown-toggle,
.app-popup-body .editionPanel .multiselect__tags {
  background: #ffffff !important;
  color: #1e2a44 !important;
  border: 1px solid #dbe4f0 !important;
  box-shadow: none !important;
}

.app-popup-body .editionPanel .form-control::placeholder,
.app-popup-body .editionPanel textarea::placeholder {
  color: #94a3b8 !important;
}

.app-popup-body .editionPanel .multiselect__input,
.app-popup-body .editionPanel .multiselect__single,
.app-popup-body .editionPanel .vs__selected,
.app-popup-body .editionPanel option {
  background: transparent !important;
  color: #1e2a44 !important;
}

.app-popup-body .__container,
.app-popup-body .__containerSub {
  width: 100% !important;
  margin: 0 !important;
  padding: 0 !important;
  background: transparent !important;
}

.app-popup-body .sublisteMode,
.app-popup-body .sublisteModeFull,
.app-popup-body .listeMode,
.app-popup-body .lightMode {
  border-radius: 16px !important;
  box-shadow: none !important;
}

.managerPopup {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.managerPopup-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
}

.managerPopup-title {
  margin: 0 0 6px;
  color: #1e2a44;
  font-size: 24px;
  font-weight: 700;
}

.managerPopup-subtitle {
  color: #5f6f8b;
  font-size: 14px;
}

.managerPopup-card {
  padding: 18px;
  border-radius: 22px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
  border: 1px solid #dbe4f0;
  box-shadow: 0 16px 32px rgba(15, 23, 42, 0.1);
}

.dashboard-shell .content {
  width: 100%;
  max-width: 1140px;
  margin: 0 auto;
  padding-left: 8px;
  padding-right: 8px;
}

.dashboard-shell .pageHeader {
  left: 0 !important;
  right: 0 !important;
  width: 100% !important;
  max-width: 100% !important;
  transform: none !important;
  background: #000 !important;
}

.dashboard-shell .pageHeader .subMenu {
  width: min(1140px, calc(100vw - 16px)) !important;
  margin-left: auto !important;
  margin-right: auto !important;
  padding-left: 8px !important;
  padding-right: 8px !important;
  background: transparent !important;
}

.dashboard-shell .mainPanelWithoutFilter {
  width: 100%;
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.dashboard-shell .listeMode,
.dashboard-shell .lightMode,
.dashboard-shell .editMode,
.dashboard-shell .sublisteMode,
.dashboard-shell .sublisteModeFull {
  position: relative;
  margin-bottom: 14px !important;
  padding: 16px 18px !important;
  border-radius: 20px !important;
  border: 1px solid #dde7f2 !important;
  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%) !important;
  box-shadow: 0 12px 26px rgba(15, 23, 42, 0.07) !important;
  overflow: hidden;
  transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease;
}

.dashboard-shell .lightMode {
  background: linear-gradient(180deg, #f9fbfd 0%, #f1f5f9 100%) !important;
}

.dashboard-shell .listeMode:hover,
.dashboard-shell .lightMode:hover,
.dashboard-shell .editMode:hover,
.dashboard-shell .sublisteMode:hover,
.dashboard-shell .sublisteModeFull:hover {
  transform: translateY(-1px);
  border-color: #c9d8eb !important;
  box-shadow: 0 18px 36px rgba(15, 23, 42, 0.12) !important;
}

.dashboard-shell .listeMode > .row,
.dashboard-shell .lightMode > .row,
.dashboard-shell .editMode > .row {
  align-items: center;
  margin: 0 !important;
}

.dashboard-shell .listeMode > .row > [class*="col-"],
.dashboard-shell .lightMode > .row > [class*="col-"],
.dashboard-shell .editMode > .row > [class*="col-"] {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 6px;
  font-size: 14px;
}

.dashboard-shell .listeMode b,
.dashboard-shell .lightMode b,
.dashboard-shell .editMode b,
.dashboard-shell .sublisteMode .subPreview,
.dashboard-shell .sublisteModeFull .subPreview,
.dashboard-shell .preview {
  color: #1e2a44;
}

.dashboard-shell .listeMode em,
.dashboard-shell .lightMode em,
.dashboard-shell .editMode em,
.dashboard-shell .sublisteMode em,
.dashboard-shell .sublisteModeFull em {
  color: #7b879c;
}

.dashboard-shell .listeMode .menu,
.dashboard-shell .lightMode .menu,
.dashboard-shell .editMode .menu,
.dashboard-shell .sublisteMode .subMenu,
.dashboard-shell .sublisteModeFull .subMenu {
  float: none !important;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  background: transparent !important;
}

.dashboard-shell .productThumb {
  width: 100% !important;
  height: 100% !important;
  object-fit: cover;
  border-radius: inherit !important;
}

.app-popup-shell-compact .modal-dialog {
  max-width: 880px !important;
}

.modal-content:not(.app-popup-content) {
  border: 0 !important;
  border-radius: 22px !important;
  background: linear-gradient(180deg, #fdfefe 0%, #f3f7fb 100%) !important;
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.24) !important;
  overflow: hidden;
}

.modal-content:not(.app-popup-content) .modal-header {
  padding: 18px 22px 14px !important;
  border-bottom: 1px solid #e2e8f0 !important;
  background: linear-gradient(180deg, #f8fbff 0%, #eef3f8 100%) !important;
}

.modal-content:not(.app-popup-content) .modal-title {
  color: #1e2a44;
  font-size: 20px;
  font-weight: 700;
}

.modal-content:not(.app-popup-content) .modal-body {
  padding: 20px 22px 8px !important;
  color: #334155;
  font-size: 15px;
  line-height: 1.6;
}

.modal-content:not(.app-popup-content) .modal-footer {
  padding: 14px 22px 20px !important;
  border-top: 0 !important;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.modal-content:not(.app-popup-content) .modal-footer > * {
  margin: 0 !important;
}

.modal-content:not(.app-popup-content) .modal-footer .btn {
  min-width: 122px;
  min-height: 42px;
  border: 0;
  border-radius: 12px;
  font-weight: 700;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.12);
}

.modal-content:not(.app-popup-content) .modal-footer .btn-secondary {
  background: #1e2a44 !important;
  color: #fff !important;
}

.modal-content:not(.app-popup-content) .modal-footer .btn-secondary:hover {
  background: #31415f !important;
}

.modal-content:not(.app-popup-content) .modal-footer .btn-danger,
.modal-content:not(.app-popup-content) .modal-footer .btn-primary {
  background: linear-gradient(135deg, #ff4d6d 0%, #ff6b6b 100%) !important;
  color: #fff !important;
}

.modal-content:not(.app-popup-content) .modal-footer .btn-danger:hover,
.modal-content:not(.app-popup-content) .modal-footer .btn-primary:hover {
  filter: brightness(0.98);
}

.inlineOptionTrigger {
  width: 32px;
  height: 32px;
  min-width: 32px;
  min-height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background: #4b587c;
  color: #fff;
  cursor: pointer;
  box-shadow: 0 5px 12px rgba(31, 42, 68, 0.16);
  transition: transform 0.18s ease, background-color 0.18s ease;
  font-size: 13px !important;
  line-height: 1;
  padding: 4px !important;
  overflow: hidden;
}

.inlineOptionTrigger:hover {
  transform: translateY(-1px);
  background: #617094;
}

.directoryCard-menu .menu {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  padding: 10px;
  border: 0;
  border-radius: 12px;
  background: oklch(0.99 0.004 264) !important;
  box-shadow: 0 6px 16px rgba(15, 18, 26, 0.24);
}

.directoryCard-menu .menu .btnIco {
  float: none;
  margin: 0;
}

.dashboard-shell .recordLightCard {
  display: grid;
  grid-template-columns: minmax(0, 1.4fr) auto minmax(220px, 1fr);
  align-items: center;
  gap: 16px;
}

.dashboard-shell .recordLightIdentity,
.dashboard-shell .recordLightAmount,
.dashboard-shell .recordLightActions {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.dashboard-shell .recordLightRef,
.dashboard-shell .recordCardNumber {
  color: #1e2a44;
  font-size: 18px;
  font-weight: 800;
  line-height: 1.15;
}

.dashboard-shell .recordLightMeta,
.dashboard-shell .recordCardType,
.dashboard-shell .recordCardDate {
  color: #7b879c;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.dashboard-shell .recordLightAmount {
  align-items: flex-end;
}

.dashboard-shell .recordLightAmount span,
.dashboard-shell .recordCardAmountLabel {
  color: #7b879c;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.dashboard-shell .recordLightAmount b,
.dashboard-shell .recordCardAmountValue {
  color: #0f5132;
  font-size: 22px;
  font-weight: 800;
  line-height: 1;
}

.dashboard-shell .recordLightActions {
  align-items: flex-end;
  justify-content: center;
}

.dashboard-shell .recordLightActions .btn,
.dashboard-shell .recordActions .btn {
  min-width: 190px;
  min-height: 40px;
  border: 0;
  border-radius: 12px;
  font-weight: 700;
  box-shadow: 0 10px 22px rgba(15, 23, 42, 0.12);
}

.dashboard-shell .recordCard {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.dashboard-shell .recordCardTop {
  display: grid;
  grid-template-columns: minmax(170px, 0.95fr) minmax(220px, 1.3fr) minmax(150px, 0.7fr);
  gap: 18px;
  align-items: start;
}

.dashboard-shell .recordCardIdentity,
.dashboard-shell .recordCardClient,
.dashboard-shell .recordCardAmount {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.dashboard-shell .recordCardOwner {
  color: #1e2a44;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.22;
}

.dashboard-shell .recordCardType {
  letter-spacing: 0.06em;
}

.dashboard-shell .recordCardAmount {
  align-items: flex-end;
  padding: 14px 16px;
  border-radius: 16px;
  background: linear-gradient(180deg, #f7fbff 0%, #edf4fb 100%);
  border: 1px solid #dbe6f1;
}

.dashboard-shell .recordCardBody {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
}

.dashboard-shell .recordInfoBlock {
  flex: 1 1 280px;
  min-width: 0;
  padding: 16px 18px;
  border-radius: 18px;
  background: linear-gradient(180deg, #fbfdff 0%, #f2f7fb 100%);
  border: 1px solid #dbe6f1;
}

.dashboard-shell .recordInfoLabel {
  margin-bottom: 10px;
  color: #6d7b93;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.dashboard-shell .recordArticlesList {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.dashboard-shell .recordArticleRow {
  display: grid;
  grid-template-columns: 46px minmax(0, 1fr) minmax(0, 1.4fr);
  gap: 10px;
  align-items: start;
  color: #334155;
  font-size: 13px;
}

.dashboard-shell .recordArticleQty {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 38px;
  min-height: 28px;
  border-radius: 999px;
  background: rgba(37, 99, 235, 0.1);
  color: #1d4ed8;
  font-size: 12px;
  font-weight: 800;
}

.dashboard-shell .recordArticleRef {
  color: #7b879c;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.35;
}

.dashboard-shell .recordArticleName {
  color: #1e2a44;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.35;
}

.dashboard-shell .recordEmptyText {
  color: #8a97ab;
  font-size: 13px;
}

.dashboard-shell .recordCardBottom {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
  gap: 14px;
}

.dashboard-shell .recordNotif {
  flex: 1 1 240px;
  padding: 12px 14px;
  border-radius: 14px;
  background: linear-gradient(135deg, rgba(255, 189, 89, 0.12) 0%, rgba(241, 133, 27, 0.08) 100%);
  color: #b45309;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.45;
}

.dashboard-shell .recordActions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 10px;
}

.dashboard-shell .recordActions .btn,
.dashboard-shell .recordLightActions .btn {
  margin: 0 !important;
}

.dashboard-shell .recordLinkedList {
  width: 100%;
}

.dashboard-shell .recordLinkedList .row {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.dashboard-shell .recordLinkedList [class*="col-"] {
  padding-left: 0 !important;
  padding-right: 0 !important;
  flex: 0 0 100%;
  max-width: 100%;
}

.dashboard-shell .recordLinkedList .lightMode {
  margin-bottom: 0 !important;
  padding: 0 !important;
  background: transparent !important;
  border: 0 !important;
  border-radius: 0 !important;
  min-height: 0 !important;
}

.dashboard-shell .recordLinkedList .factureLightCard,
.dashboard-shell .recordLinkedList .recordLightCard {
  display: grid !important;
  grid-template-columns: minmax(0, 1fr) auto auto;
  gap: 10px;
  align-items: center;
  padding: 12px 14px;
  border-radius: 16px;
  background: linear-gradient(180deg, #fbfdff 0%, #f2f7fb 100%);
  border: 1px solid #dbe6f1;
}

.dashboard-shell .recordLinkedList .factureLightRef,
.dashboard-shell .recordLinkedList .recordLightRef {
  font-size: 12px !important;
  line-height: 1.35;
}

.dashboard-shell .recordLinkedList .factureLightMeta,
.dashboard-shell .recordLinkedList .recordLightMeta {
  font-size: 11px !important;
  line-height: 1.45;
}

.dashboard-shell .recordLinkedList .factureLightAmount,
.dashboard-shell .recordLinkedList .recordLightAmount {
  padding: 10px 12px;
  min-width: 110px;
}

.dashboard-shell .recordLinkedList .factureLightActions,
.dashboard-shell .recordLinkedList .recordLightActions {
  flex-direction: row !important;
  align-items: center !important;
  justify-content: flex-end !important;
  gap: 8px;
}

.dashboard-shell .recordLinkedList .factureLightActions .btn,
.dashboard-shell .recordLinkedList .recordLightActions .btn {
  min-width: 72px !important;
  min-height: 34px !important;
  padding: 0 12px !important;
  font-size: 12px !important;
  box-shadow: none !important;
}

@media (max-width: 767px) {
  .dashboard-shell .content {
    max-width: 100%;
    padding-left: 10px;
    padding-right: 10px;
  }

  .dashboard-shell .pageHeader {
    width: 100% !important;
    max-width: 100% !important;
  }

  .dashboard-shell .pageHeader .subMenu {
    width: calc(100vw - 20px) !important;
  }

  .app-popup-shell .modal-dialog {
    margin: 119px 0 0 !important;
    min-height: calc(100vh - 119px);
    max-width: 100% !important;
    transform: translateY(18px);
  }

  .app-popup-content {
    min-height: calc(100vh - 119px);
  }

  .modal-content:not(.app-popup-content) .modal-header,
  .modal-content:not(.app-popup-content) .modal-body,
  .modal-content:not(.app-popup-content) .modal-footer {
    padding-left: 16px !important;
    padding-right: 16px !important;
  }

  .modal-content:not(.app-popup-content) .modal-footer {
    flex-direction: column;
  }

  .modal-content:not(.app-popup-content) .modal-footer .btn {
    width: 100%;
  }

  .app-popup-body {
    padding: 16px 14px 20px !important;
    max-height: calc(100vh - 119px);
  }

  .app-popup-header {
    padding: 8px 12px 0 !important;
  }

  .dashboard-shell .listeMode,
  .dashboard-shell .lightMode,
  .dashboard-shell .editMode,
  .dashboard-shell .sublisteMode,
  .dashboard-shell .sublisteModeFull {
    padding: 14px !important;
    border-radius: 18px !important;
  }

  .dashboard-shell .recordLightCard,
  .dashboard-shell .recordCardTop {
    grid-template-columns: 1fr;
  }

  .dashboard-shell .recordLightAmount,
  .dashboard-shell .recordLightActions,
  .dashboard-shell .recordCardAmount,
  .dashboard-shell .recordActions {
    align-items: stretch;
    justify-content: flex-start;
  }

  .dashboard-shell .recordLightActions .btn,
  .dashboard-shell .recordActions .btn {
    width: 100%;
    min-width: 0;
  }

  .dashboard-shell .recordArticleRow {
    grid-template-columns: 44px 1fr;
  }

  .dashboard-shell .recordArticleName {
    grid-column: 2 / -1;
  }
}
</style>
